module.exports = __webpack_public_path__ + "img/img34.afcf8f56.jpg";